import styled from '@emotion/styled';
import type { FC } from 'react';
import React from 'react';

import Button from '../Button';

const Popup = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  & > .popup-mask {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
    left: 0;
  }

  & > .popup-card {
    position: absolute;
    width: 22rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 4rem 1.5rem;
    background-color: #ffffff;
    border-radius: 0.25rem;
    animation: popup 0.3s ease-in-out;

    @keyframes popup {
      0% {
        transform: translate(-50%, -50%) scale(0.9);
      }
      50% {
        transform: translate(-50%, -50%) scale(1.1);
      }
      100% {
        transform: translate(-50%, -50%) scale(1);
      }
    }

    & > .title {
      font-size: 1rem;
      font-weight: 500;
      color: #1f2d49;
      margin-bottom: 1rem;
      letter-spacing: 0.096rem;
    }

    & > .content {
      font-size: 0.9rem;
      color: #8b8b8b;
      letter-spacing: 0.0864rem;
      margin-bottom: 2.5rem;
    }

    & > .buttons {
      display: flex;
      gap: 1rem;
      & > button {
        width: 9rem;
      }
    }
  }
`;

type ConfirmModalProps = {
  title: string;
  content: string;
  onConfirm: () => void;
  confirmText: string;
  onCancel?: () => void;
  cancelText?: string;
};

const ConfirmModal: FC<ConfirmModalProps> = ({
  title,
  content,
  onConfirm,
  confirmText = '確認',
  onCancel,
  cancelText = '取消',
}) => {
  return (
    <Popup>
      <div className="popup-mask" />
      <div className="popup-card">
        <h2 className="title">{title}</h2>
        <p className="content">{content}</p>
        <div className="buttons">
          {onCancel && (
            <Button onClick={onCancel} $color="#69B49E" $type="outlined">
              {cancelText}
            </Button>
          )}
          <Button onClick={onConfirm} $color="#69B49E" $type="contained">
            {confirmText}
          </Button>
        </div>
      </div>
    </Popup>
  );
};

export default ConfirmModal;
